/**
 * Helpers for exchanging a Clerk browser session into a Drivenow JWT.
 */

export const CLERK_OAUTH_PENDING_KEY = "drivenow:clerk_oauth_pending";

export function markClerkOAuthPending(): void {
  try {
    sessionStorage.setItem(CLERK_OAUTH_PENDING_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearClerkOAuthPending(): void {
  try {
    sessionStorage.removeItem(CLERK_OAUTH_PENDING_KEY);
  } catch {
    // ignore
  }
}

export function isClerkOAuthPending(): boolean {
  try {
    return sessionStorage.getItem(CLERK_OAUTH_PENDING_KEY) === "1";
  } catch {
    return false;
  }
}

/** Retry getToken — Apple/OAuth callbacks can report isSignedIn before a JWT is ready. */
export async function waitForClerkToken(
  getToken: () => Promise<string | null>,
  attempts = 8,
  delayMs = 200
): Promise<string> {
  let last: string | null = null;
  for (let i = 0; i < attempts; i += 1) {
    last = await getToken();
    if (last) return last;
    await new Promise((r) => setTimeout(r, delayMs));
  }
  throw new Error("Clerk session token unavailable after OAuth");
}
